import { supabase } from '@/lib/supabase';
import type { ToolAppStatus } from '@shared/types/tool-apps';

/**
 * Managing an app outside the Forge (creator or tenant manager): publish it
 * again, put it back to draft, archive or restore it, delete it while it has
 * never been used. A Forge tool follows its app (`set_tool_app_status_m1`).
 */
const MANAGE_ERRORS: Record<string, string> = {
  tool_app_manage_forbidden: 'Seuls le créateur de l’application et les managers la gèrent.',
  tool_app_not_publishable: 'Cette application n’a pas de version publiable.',
  tool_app_in_use: 'Cette application a déjà servi : archivez-la plutôt.',
};

export const setAppStatus = async (appId: string, status: ToolAppStatus): Promise<ToolAppStatus> => {
  const { data, error } = await supabase.rpc('set_tool_app_status_m1', { p_tool_app_id: appId, p_status: status });
  if (error) throw new Error(MANAGE_ERRORS[error.message] ?? 'Le changement n’a pas pu être enregistré. Réessayez.');
  return data as ToolAppStatus;
};

/** False for an app already launched or holding objects: it is archived instead. */
export const canDeleteApp = async (appId: string): Promise<boolean> => {
  const { data, error } = await supabase.rpc('can_delete_tool_app_m1', { p_tool_app_id: appId });
  if (error) return false;
  return data === true;
};

export const deleteApp = async (appId: string): Promise<void> => {
  const { error } = await supabase.rpc('delete_tool_app_m1', { p_tool_app_id: appId });
  if (error) throw new Error(MANAGE_ERRORS[error.message] ?? 'L’application n’a pas pu être supprimée. Réessayez.');
};

export const APP_STATUS_LABELS: Record<ToolAppStatus, string> = {
  draft: 'Brouillon',
  published: 'Publiée',
  archived: 'Archivée',
};
